var _rect, _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgReceivedAmount(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 64,
    height: 64,
    rx: 32,
    fill: "#31B867",
    fillOpacity: 0.3
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M37.3334 34.6667C37.3334 35.7713 38.2288 36.6667 39.3334 36.6667C40.4379 36.6667 41.3334 35.7713 41.3334 34.6667C41.3334 33.5622 40.4379 32.6667 39.3334 32.6667C38.2288 32.6667 37.3334 33.5622 37.3334 34.6667Z",
    stroke: "#31B867",
    strokeWidth: 1.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M41.2 26.6667C41.2875 26.2359 41.3333 25.79 41.3333 25.3334C41.3333 21.6515 38.3485 18.6667 34.6667 18.6667C30.9848 18.6667 28 21.6515 28 25.3334C28 25.79 28.0459 26.2359 28.1334 26.6667",
    stroke: "#31B867",
    strokeWidth: 1.5
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M25.3333 26.6576H37.3333C41.1045 26.6576 42.9901 26.6576 44.1617 27.8297C45.3333 29.0019 45.3333 30.8883 45.3333 34.6614V37.3294C45.3333 41.1025 45.3333 42.989 44.1617 44.1611C42.9901 45.3333 41.1045 45.3333 37.3333 45.3333H29.3333C24.305 45.3333 21.7908 45.3333 20.2287 43.7705C18.6666 42.2075 18.6666 39.6922 18.6666 34.6614V31.9935C18.6666 26.9627 18.6666 24.4474 20.2287 22.8845C21.4862 21.6265 23.3605 21.3811 26.6666 21.3333H29.3333",
    stroke: "#31B867",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReceivedAmount);
export default __webpack_public_path__ + "static/media/received-amount.b2a04373e2308b72de55771004de4d64.svg";
export { ForwardRef as ReactComponent };